import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChange, SimpleChanges, ViewChildren, forwardRef, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DrakeFieldComponent } from 'app/drake-components/drake-field/drake-field.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GridService } from 'app/services/grid.service';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-drake-view-wizard',
  templateUrl: './drake-view-wizard.component.html',
  styleUrls: ['./drake-view-wizard.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslocoPipe, InputsModule, forwardRef(() => DrakeFieldComponent)]
})
export class DrakeViewWizardComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() viewConfig: any;
  @Input() baseData: any;
  @Input() readonly: boolean = false;
  @Input() matrix: boolean = false;
  @Input() scope: string;
  @Input() forcedId: string;
  @Input() nextOperation: any;
  private preloadDone = false;
  private urlScope: string;


  protected id: string;
  private userId: string;
  private loaded: boolean = false;
  activeStepIndex = 0;

  @Output() public fieldValueChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(DrakeFieldComponent) drakeFields: QueryList<DrakeFieldComponent>;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, public translocoPipe: TranslocoPipe, private gridService: GridService, private cdRef: ChangeDetectorRef, private drakeSharedService: DrakeSharedService) {
    this.activatedRoute.params.subscribe(params => {
      this.urlScope = params?.['scope'];
      if (!this.scope) {
        this.id = decodeURIComponent(params?.['id'] || "#NEWID#");
        this.scope = params?.['scope'];
      }
      else
        this.id = "#NEWID#";
    })
  }

  ngOnInit(): void {
    const user = localStorage.getItem('user');
    const userObj = JSON.parse(user);
    this.userId = userObj.id;
    /*if(this.forcedId)
      this.id = this.forcedId

    var dataToSave = {
      _id: this.userId,
      DomCode: userObj.domCode,
    };

    this.gridService.saveScopeData(this.urlScope, "UPSERT", dataToSave, false).subscribe((result: any) => {
      console.log(this.urlScope + " - " + this.userId, result)

      var notification = this.translocoPipe.transform("notification.success.scopeForm.save");
      //this.drakeSharedService.showTemporaryNotification(notification, 'success');
    },
      (err: any) => {
        console.log(err)
        var notification = this.translocoPipe.transform("notification.error.scopeForm.save");
        //this.drakeSharedService.showTemporaryNotification(notification, 'error');
      }
    );*/


    //this.getAnswers(this.id);


  }

  getAnswers(id) {

    var scopeToRead = this.viewConfig.viewCode.split(".")[0];

    this.baseData[scopeToRead] = {};

    this.gridService.getScopeDataSimple(scopeToRead, "READ", { viewCode: this.viewConfig.viewCode, filter: `{ "idSessione": "${this.id}" }` }).subscribe(result => {

      this.loaded = true;
      if (result.data.length == 1)
        Object.assign(this.baseData[scopeToRead][result.data[0]._id], result.data[0]);
      for (let k of Object.keys(this.baseData[scopeToRead][result.data[0]._id])) {
        const newKey = k.includes('$') ? k.split('$')[1] : k;
        this.baseData[scopeToRead][result.data[0]._id][newKey] = this.baseData[scopeToRead][result.data[0]._id][k];
      }
      this.baseData = { ...this.baseData };
      this.fieldValueChanged.emit({ all: true });

      this.drakeSharedService.baseData$.next(this.baseData)
    })

    console.log("BaseData dopo READ", this.baseData)

  }

  ngAfterViewInit(): void {
  }

  private preloadAllOptions() {
    if (this.preloadDone) return;
    if (!this.viewConfig?.viewFields?.length) return;

    const fieldCodes = [...new Set(
      this.viewConfig.viewFields
        .filter(f =>
          f?.fieldCode &&
          (f.fieldControlType === 'DROPDOWNLIST' || f.fieldControlType === 'DRPLISTBOX' || f.fieldControlType === 'RADIO')
        )
        .map(f => f.fieldCode)
    )];

    if (!fieldCodes.length) {
      this.preloadDone = true;
      return;
    }

    const toLoad = fieldCodes.filter(fc => !this.drakeSharedService.drpOptions[fc as string]);

    if (!toLoad.length) {
      this.preloadDone = true;
      return;
    }

    forkJoin(
      toLoad.map(fc =>
        this.gridService.getDropDownValues(fc as string).pipe(
          tap(res => this.drakeSharedService.drpOptions[fc as string] = res),
          tap(res => console.log(fc)),
          catchError(err => {
            console.error('Preload options failed for', fc, err);
            return of([]);
          })
        )
      )
    ).subscribe(() => {
      this.preloadDone = true;
    });

    console.log(this.drakeSharedService.drpOptions)
  }

  valueChanged(ev) {
    console.log("Value changed drake view");
    this.fieldValueChanged.emit(ev)
    if (!this.viewConfig.invalidFields)
      this.viewConfig.invalidFields = [];
    if (ev.isValid)
      this.viewConfig.invalidFields = this.viewConfig.invalidFields.filter(f => f != ev.field);
    else
      this.viewConfig.invalidFields.push(ev.field);
  }

  updateChildren() {
    this.drakeFields.forEach(f => f.loadFields()); // o un metodo che forza il refresh
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("changes view ", changes);
    //console.log("changes view code",  { viewCode: this.viewConfig.viewCode, filter: `{ "_id": "${this.id}" }` });

    if (changes.scope) {
      //this.id = "#NEWID#";
    }

    if (changes['viewConfig']?.currentValue) {
      this.preloadAllOptions();
    }

    /*if (this.forcedId)
      this.id = this.forcedId*/

    if (!this.matrix) {
      this.baseData[this.scope] = this.baseData[this.scope] ?? {};
      this.baseData[this.scope][this.id] = this.baseData[this.scope][this.id] ?? {};

      if (this.id && this.id != "#NEWID#" && this.viewConfig && !this.loaded) {

        this.id = decodeURIComponent(this.id);
        this.gridService.getScopeDataSimple(this.scope, "READ", { viewCode: this.viewConfig.viewCode, filter: `{ "idSessione": "${this.id}" }` }).subscribe(result => {

          this.loaded = true;
          //console.log("callresult", result);
          if (result.data.length == 1)
            Object.assign(this.baseData[this.scope][this.id], result.data[0]);
          for (let k of Object.keys(this.baseData[this.scope][this.id])) {
            const newKey = k.includes('$') ? k.split('$')[1] : k;
            this.baseData[this.scope][this.id][newKey] = this.baseData[this.scope][this.id][k];
          }
          this.baseData = { ...this.baseData };
          //console.log('basedata after call', this.baseData)
          this.fieldValueChanged.emit({ all: true });

          //Promise.resolve().then(() => this.cdRef.markForCheck());
          //this.updateChildren();
          this.drakeSharedService.baseData$.next(this.baseData)
        })
      }
    }
    else {
      this.scope = Object.keys(this.baseData)[0];
      this.id = Object.keys(this.baseData[this.scope])[0];
    }


  }

  get currentField() {
    return this.viewConfig.viewFields[this.activeStepIndex];
  }

  nextStep() {
    if (this.activeStepIndex < this.viewConfig.viewFields.length - 1) {
      this.activeStepIndex++;
    }
  }

  prevStep() {
    if (this.activeStepIndex > 0) {
      this.activeStepIndex--;
    }
  }

  goToStep(index: number) {
    // Opzionale: permetti il salto solo se lo step è già stato visitato o completato
    this.activeStepIndex = index;
  }

  onNextClick() {
  const isLastStep = this.activeStepIndex === this.viewConfig.viewFields.length - 1;
  const btnType = this.getTxtButton();

  if (!isLastStep) {
    this.nextStep();
    return;
  }

  if (btnType === 'SENDSURV') {
    this.submitAnswer();
    return;
  }

  if (btnType === 'NEXTSURV') {
    this.submitAnswer();
    return;
  }
}

  getTxtButton(){
    if((this.nextOperation != undefined && this.nextOperation.operation != undefined && this.nextOperation.operation == 'GOTOTAB') && this.activeStepIndex === this.viewConfig.viewFields.length - 1)
      return "NEXTSURV"
    if((this.nextOperation != undefined && this.nextOperation.operation != undefined && this.nextOperation.operation != 'GOTOTAB') && this.activeStepIndex === this.viewConfig.viewFields.length - 1)
      return "SENDSURV"
    else
      return "NEXTQUEST"
  }

  submitAnswer() {
   const btnType = this.getTxtButton();

    if (btnType === 'SENDSURV') {
      this.drakeSharedService.saveScopeFormSubject.next(false);
      return;
    }

    if (btnType === 'NEXTSURV') {
      if (this.nextOperation?.operation === 'GOTOTAB') {
        this.drakeSharedService.changeTabSubject.next(this.nextOperation.detail);
      }
      return;
    }
    /*console.log(this.baseData);
    console.log(this.viewConfig);
    var scopeToSave = this.viewConfig.viewCode.split(".")[0];

    this.baseData[this.scope][this.id]['idSessione'] = this.userId;
    //this.baseData[this.scope][this.id]['_id'] = '#NEWID#'


    this.gridService.saveScopeData(scopeToSave, "UPSERT", this.baseData[this.scope][this.id], false).subscribe((result: any) => {
            console.log(scopeToSave + " - " + this.id, result)

            var notification = this.translocoPipe.transform("notification.success.scopeForm.save");
            this.drakeSharedService.showTemporaryNotification(notification, 'success');
          },
            (err: any) => {
              console.log(err)
              var notification = this.translocoPipe.transform("notification.error.scopeForm.save");
              this.drakeSharedService.showTemporaryNotification(notification, 'error');
            }
          );
*/
  }
}
